import { Directive, Self } from '@angular/core';
import { NgControl } from '@angular/forms';

const controlStatusHost = {
    "[class.is-valid]": "ngClassValid",
    "[class.is-invalid]": "ngClassInvalid"
};

@Directive({
    selector: "[formControlName],[ngModel],[formControl],[bcui-date-picker-input]", host: controlStatusHost,
    standalone: false
})
export class BootstrapControlDirective {

    public constructor(@Self() private control: NgControl) {
    }

    // get ngClassValid(): boolean {
    //     if (this.control.control == null) {
    //         return false;
    //     }
    //     return this.control.control.valid;
    // }

    get ngClassInvalid(): boolean {
        if (this.control.control == null) {
            return false;
        }
        return this.control.control.invalid && this.control.control.touched;
    }
}